/**
 * @file: makePlaceholderChatIdentity.ts
 *
 * Builds a fully-shaped placeholder `ChatUserIdentity` for an
 * unauthenticated viewer. Routing keeps every chat surface off-screen until
 * login, so it's normally never read — but on logout the chat providers can
 * re-render with no user for a frame before they tear down, and a
 * `{}`-cast-to-any would crash the moment any of them touches a field. Every
 * required field carries its zero value; optional fields are omitted.
 */

import { PlatformAppId } from '@euler/model/enum';
import { ChatUserIdentity } from '../lib/types';

export function makePlaceholderChatIdentity(): ChatUserIdentity {
  return {
    platformUserId: 0,
    platformUid: '',
    platformAppId: 0,
    user: {
      userId: 0,
      uid: '',
      memberId: 0,
      orgId: 0,
      storeId: 0,
      userName: '',
      role: '',
      isMobileVerified: false,
      name: '',
      jobTitle: '',
      enabled: false,
      createdAt: '',
      isDefaultPassword: false,
      permissions: { dialCustomer: false },
    },
    app: {
      id: 0,
      userId: 0,
      appId: PlatformAppId.Workbench,
      appName: '',
      scope: '',
      orgId: 0,
      storeId: 0,
      enabled: false,
      isDefault: false,
      isPasswordProvisional: false,
      isPasswordLoginEnabled: false,
      createdAt: '',
    },
  };
}
